@if (content) {
<div class="p-t-16 p-t-10-s p-t-10-m p-b-15 p-b-10-s p-b-10-m">
    <div class="wrap">
        @if(calculator) {
        <p class="o1">{{'We’re here to help' | translate}}</p>
        <h2 class="m-t-1"
            [sizeClass]="'SM: h2, XL: h1'"
            *iCms="(calculator.id + 'Title') of content"></h2>

        <ng-container *ifSize="'XL'">
            <p class="p1 m-t-2 col-11 c-6 m-b-0"
               *iCms="(calculator.id + 'Description') of content"></p>
        </ng-container>
        }
    </div>
    <carousel class="default-scrollbar wrap swiper-show-outside-wrap p-t-6 _calcs"
              [slidesPerView]="'auto'"
              [freeMode]="true"
              [spaceBetween]="12"
              [scrollbar]="{ draggable: true }">
        @for(item of calculatorsList; track $index) {
        @if(item.id !== calculator?.id) {
        <ng-template swiperSlide>
            <a class="p-l-3 p-r-3 s2 block m-b-2-s m-b-2-m _link b-radius-4"
               [routerLink]="item.url"
               *iCms="(item.id + 'Title') of content"></a>
        </ng-template>
        }
        }
    </carousel>
    <!-- fields -->

    @for(field of calculator?.fields; track $index) {
    @if(field.title) {
    <h3 class="wrap h3 m-t-10 m-t-6-s">{{field.title | translate}}</h3>

    }
    @switch (field.type) {
    @case (EFieldType.input) {
    <div class="wrap m-t">
        <form-mui-field [label]="(field.label || '') | translate"
                        [style.max-width.px]="395">
            <input class="input"
                   type="number"
                   [name]="field.id"
                   [(ngModel)]="fieldsValue[field.id]"
                   [required]="field.required || false"
                   (ngModelChange)="detectChanges()" />
        </form-mui-field>
    </div>
    }
    @case (EFieldType.selector) {
    <div class="wrap m-t">
        <form-mui-field [label]="(field.label || '') | translate"
                        [style.max-width.px]="395">
            <select class="input"
                    [name]="field.id"
                    [(ngModel)]="fieldsValue[field.id]"
                    [required]="field.required || false"
                    (ngModelChange)="detectChanges()">
                <option *ngFor="let option of field.options"
                        [value]="option.id">{{option.label}}</option>
            </select>
        </form-mui-field>
    </div>
    }
    @case (EFieldType.image) {
    @for(group of field.imageOptions; track $index) {
    @if(group.group) {
    <h4 class="wrap s1 m-t-8 m-t-6-m m-t-4-s">{{group.group | translate}}</h4>
    }
    <carousel class="default-scrollbar wrap swiper-show-outside-wrap wrap  p-t _images"
              [slidesPerView]="'auto'"
              [freeMode]="true"
              [spaceBetween]="client.isS ? 8 : 16">
        @for(option of group.options; track $index) {
        <ng-template swiperSlide>
            <div class="bg-col-51 b-radius-4 b-a _imageOption cursor-pointer"
                 (click)="selectImageOption(field, option, group.group)"
                 [class._selected]="fieldsValue[field.id] === option.id">
                <div class="ratio-1-1 overflow-hidden">
                    <shell></shell>
                    <img [fill]="true"
                         [ratio]="1"
                         [dfImage]="content[option.imageCmsName || '']"
                         [loaderParams]="{fitIn: true}" />
                    <button class="b-radius-max bg-col-6 pos-absolute top-2 right-2 inline-flex _tick"
                            [style.padding.px]="5">
                        <i class="icon-tick col-w inline-flex"
                           [style.font-size.px]="14"></i>
                    </button>
                </div>
                <div class="p-a-2 flex flex-justify-between flex-middle">
                    <p class="p1"
                       [ngClass]="fieldsValue[field.id] === option.id ? 'col-1' : 'col-12'">{{option.label | translate}}
                    </p>
                    @if(option.additionalInfo) {
                    <div class="_tooltip inline-flex">
                        <i class="icon-info icon-small inline-flex"></i>
                        <span class="_tooltiptext c2">{{option.additionalInfo | translate}}</span>
                    </div>
                    }
                </div>
            </div>
        </ng-template>
        }
    </carousel>
    }
    }
    }
    }
    <div class="wrap m-t">
        <button [buttonStyle]
                [disabled]="!this.isValid()"
                (click)="calculate()">{{'Calculate materials' | translate}}</button>
        <div id="calcResults">
            @if(results) {
            <div class="m-t-10 m-t-8-s b-radius-4 b-a b-col-5 bg-col-51 p-a">
                <p class="h3">{{'Results' | translate}}</p>
                <p class="m-t"
                   [sizeClass]="'SM: s1, XL: h4'">{{'Required Materials' | translate}}:</p>
                <p class="h3 m-t-2 col-3">
                    {{results.materialsValue}}&nbsp;
                    {{results.materialsNote | translate}}</p>
                @if(results.note) {
                <p class="c1 col-12 m-t-1">{{'Note' | translate}}:&nbsp;{{results.note}}</p>
                }
                <div class="_line m-t m-b"></div>
                <p [sizeClass]="'SM: s1, XL: h4'">{{'Area covered' | translate}}:</p>
                <p class="h3 m-t-2 col-3">{{results.area}} {{results.areaUnit}}</p>
                @for (item of results.additionalInfo; track $index) {
                <div class="_line m-t m-b"></div>
                <p><span [sizeClass]="'SM: s1, XL: h4'">{{item.value}}</span>&nbsp;<span
                          [sizeClass]="'SM: p2, XL: p1'">{{item.note | translate}}</span></p>
                }
                <div class="_line m-t m-b"></div>
                <button [buttonStyle]
                        (click)="quote()">{{'Get a quote' | translate}}</button>
            </div>
            }
        </div>

        @if (calculator?.doc) {
        <div class="m-t-14 m-t-8-s bg-col-51 b-a b-col-5 b-radius-4 p-a"
             style="width: fit-content;">
            <p [sizeClass]="'SM: s1, XL: h3'">{{'Download printable version!'}}</p>
            <p [sizeClass]="'SM: p2, XL: p1'"
               class="m-t">{{'Download and print out our pdf version of the paving patterns.' | translate}}</p>
            <a class="m-t"
               [attr.href]="url.toMediaUrl(content[calculator?.id + 'Doc'])"
               target="_blank"
               [buttonStyle]>{{'Get PDF' | translate}}</a>
        </div>
        }
    </div>
</div>
}
